"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetChatAssets = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const useScrollLock_1 = require("./useScrollLock");
const useGetChatAssets = (assetType) => {
    const { chat } = (0, react_1.useContext)(context_1.ChatContext);
    const [isChatAssetsLoading, setIsChatAssetsLoading] = (0, react_1.useState)(false);
    const { concurrencySafe } = (0, useScrollLock_1.useScrollLock)();
    function getChatAssets() {
        return __awaiter(this, void 0, void 0, function* () {
            yield concurrencySafe(() => __awaiter(this, void 0, void 0, function* () {
                if (chat && !isChatAssetsLoading && assetType) {
                    setIsChatAssetsLoading(true);
                    yield chat.getGroupAssets(assetType);
                    setIsChatAssetsLoading(false);
                }
            }));
        });
    }
    (0, react_1.useEffect)(() => {
        getChatAssets();
    }, [chat]);
    return { getChatAssets, isChatAssetsLoading };
};
exports.useGetChatAssets = useGetChatAssets;
